import React from "react";

export const LoadingSpinner: React.FC = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      data-testid="loading-spinner"
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};
